import { addRecord, getRecordById, updateRecord } from "../../../localDB";
import { accountMapping, statusMapping, sessionType, planWorksheetStatusMapping, orderStatus } from "../../../visualizations/visualizations";

export async function transformOrders(rawOrder) {
    return rawOrder.map(order => {

        return {
            ID: order.id,
            OrderNumber: order?.orderNumber ?? null,
            OrderDate: order?.orderDate ?? null,
            SessionID: order?.sessionID ?? null,
            Account: {
                ID: order?.account?.id,
                Name: order?.account?.name
            },
            GrossTotal: order?.grossTotal ?? null,
            TotalDiscount: order?.totalDiscount ?? null,
            NetTotal: order?.netTotal ?? null,
            DeliveryAddress: order?.deliveryAddress ?? null,
            Remarks: order?.remarks ?? null,
            Authorizer: order?.authorizer ?? null,
            Status: orderStatus[order?.status] ?? null
        };
    });
}

export async function transformOrder(rawOrder) {

    if (!rawOrder) return null;

    return {
        ID: rawOrder.id,
        OrderNumber: rawOrder?.orderNumber ?? null,
        OrderDate: rawOrder?.orderDate ?? null,
        SessionID: rawOrder?.sessionID ?? null,
        Account: {
            ID: rawOrder?.account?.id,
            Name: rawOrder?.account?.name
        },
        GrossTotal: rawOrder?.grossTotal ?? null,
        TotalDiscount: rawOrder?.totalDiscount ?? null,
        NetTotal: rawOrder?.netTotal ?? null,
        DeliveryAddress: rawOrder?.deliveryAddress ?? null,
        Remarks: rawOrder?.remarks ?? null,
        Authorizer: rawOrder?.authorizer ?? null,
        Status: orderStatus[rawOrder?.status] ?? null
    };
}

export async function upsertLocalDataOrders(orders) {
    for (const order of orders) {
        const existingOrder = await getRecordById("Orders", order.ID);

        if (existingOrder) {
            await updateRecord("Orders", order);
        } else {
            await addRecord("Orders", order);
        }
    }
}

export async function transformOrderDetails(rawOrderDetails, orderID) {
    return rawOrderDetails.map(detail => {

        return {
            ID: detail.id,
            OrderID: orderID,
            Item: {
                ID: detail?.item?.id,
                Code: detail?.item?.code,
                Description: detail?.item?.description,
            },
            Unit: {
                ID: detail?.unit?.id,
                Description: detail?.unit?.description,
            },
            DetailPrice: detail?.detailPrice ?? null,
            Quantity: detail?.quantity ?? null,
            FreeGoods: detail?.freeGoods ?? null,
            DiscountPercent: detail?.discountPercent ?? null,
            DiscountValue: detail?.discountValue ?? null,
            GrossLineTotal: detail?.grossLineTotal ?? null,
            NetLineTotal: detail?.netLineTotal ?? null,
            Remarks: detail?.remarks ?? null
        };
    });
}

export async function upsertLocalDataOrderDetails(orderDetails) {
    for (const item of orderDetails) {
        const existingItem = await getRecordById("OrderDetails", item.ID);

        if (existingItem) {
            await updateRecord("OrderDetails", item);
        } else {
            await addRecord("OrderDetails", item);
        }
    }
}